<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
  >
    <v-file-input
      v-if="!isThumbnail"
      v-bind="schema.attributesTextField"
      v-model="value"
      :rules="rules"
      :name="schema.model"
      :id="schema.model"
      :ref="schema.model"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      :disabled="schema.attributesTextField.readonly"
    >
      <template v-slot:label>
        {{ schema.attributesTextField.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>

      <template v-slot:selection="{ text }" v-if="schema.attributesChips.visible">
        <v-chip v-bind="schema.attributesChips">{{ text }}</v-chip>
      </template>
    </v-file-input>

    <template v-else>
      <v-hover v-slot:default="{ hover }" v-if="ecmDocument && isImages">
        <v-card class="card" :elevation="hover ? 12 : 2" v-bind="schema.attributesFile.card">
          <v-img :src="ecmDocument.content" v-bind="schema.attributesFile.image">
            <v-row v-if="hover" align="center" justify="center" class="hover-card-image">
              <v-col cols="12">
                <v-card-text v-text="schema.attributesTextField.label" class="text-h5 font-weight-bold"></v-card-text>
                <v-card-text>{{ ecmDocument.fileName }}</v-card-text>
                <v-card-text class="font-weight-bold">{{ ecmDocument.kBytesNumber }}</v-card-text>

                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      data-has-tooltip="true"
                      data-tooltip="Deletar Arquivo"
                      :id="`icon-delete-ecm-${schema.model}`"
                      :name="`icon-delete-ecm-${schema.model}`"
                      text
                      icon
                      dark
                      v-on="on"
                      @click="deleteDocument"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar Arquivo</span>
                </v-tooltip>

                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      data-has-tooltip="true"
                      data-tooltip="Baixar Arquivo"
                      :id="`icon-download-ecm-${schema.model}`"
                      :name="`icon-download-ecm-${schema.model}`"
                      text
                      icon
                      dark
                      v-on="on"
                      @click="downloadDocument"
                    >
                      <v-icon>get_app</v-icon>
                    </v-btn>
                  </template>
                  <span>Baixar Arquivo</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-img>
        </v-card>
      </v-hover>

      <v-card v-if="ecmDocument && !isImages" v-bind="schema.attributesFile.card">
        <v-card-title class="text-center">
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on }">
              <v-icon
                :data-has-tooltip="ecmDocument.contentType ? 'true' : 'false'"
                :data-tooltip="ecmDocument.contentType"
                large
                left
                v-on="on"
                >{{ ecmDocument.contentType }}</v-icon
              >
            </template>
            <span>{{ ecmDocument.fileName }}</span>
          </v-tooltip>

          <span class="text-h6 font-weight-light">{{ ecmDocument.kBytesNumber }}</span>
        </v-card-title>

        <v-card-text class="text-h5 font-weight-bold" v-text="schema.attributesTextField.label"></v-card-text>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row align="center" justify="end">
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on }">
                  <v-btn
                    data-has-tooltip="true"
                    data-tooltip="Deletar Arquivo"
                    :id="`icon-delete-ecm-${schema.model}`"
                    :name="`icon-delete-ecm-${schema.model}`"
                    text
                    icon
                    v-on="on"
                    @click="deleteDocument()"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Deletar Arquivo</span>
              </v-tooltip>

              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on }">
                  <v-btn
                    data-has-tooltip="true"
                    data-tooltip="Baixar Arquivo"
                    :id="`icon-download-ecm-${schema.model}`"
                    :name="`icon-download-ecm-${schema.model}`"
                    text
                    icon
                    v-on="on"
                    @click="downloadDocument()"
                  >
                    <v-icon>get_app</v-icon>
                  </v-btn>
                </template>
                <span>Baixar Arquivo</span>
              </v-tooltip>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import * as HANDLERS from '@/helpers/types/handlers';
import { formatBytes, getIcon, downloadFile } from '@/helpers/utils';
import ECM from '@/services/ecm';
import Swal from 'sweetalert2';
import validatorAcceptInputFileMixin from '@/mixins/validator-accept-input-file-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, validatorAcceptInputFileMixin],

  watch: {
    value(newValue, oldValue) {
      this.schema.hasConditions && this.$store.dispatch('page/conditions', this.formOptions);

      this.verifyModelNumber();

      if (newValue) {
        const validAccept = this.validatorAcceptInputFile(this.schema.attributesTextField, newValue);

        if (!validAccept) {
          setTimeout(() => {
            this.value = null;
          }, 10);
        }
      }
    }
  },

  created() {
    this.verifyModelNumber();
  },

  data() {
    return {
      isThumbnail: false,
      isImages: false,
      ecmDocument: null
    };
  },

  methods: {
    verifyModelNumber() {
      if (this.model && typeof this.model[this.schema.model] == 'number') {
        this.isThumbnail = true;

        this.createThumbnail();
      }
    },

    async createThumbnail() {
      const { data: dataGetDocumentDetail } = await ECM.GetDocumentDetail(this.getHash());
      const { data: dataReturnImageContent } = await ECM.ReturnImageContent(this.getHash());

      this.ecmDocument = {
        content: dataReturnImageContent,
        kBytesNumber: formatBytes(dataGetDocumentDetail.kBytesNumber),
        fileName: dataGetDocumentDetail.fileName,
        contentType: getIcon(dataGetDocumentDetail.contentType)
      };

      this.isImages = dataGetDocumentDetail.contentType.includes('image/');
    },

    getHash() {
      let hash = this.model[`${this.schema.model}_id_documento`].toString().padStart(9, '0');

      return `${hash}${this.model[this.schema.model]}`;
    },

    async deleteDocument() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: `v-btn v-size--default primary`,
          cancelButton: `v-btn v-size--default error`
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: 'Deseja realmente deletar esse arquivo?',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        })
        .then(async result => {
          if (result.value) {
            const { data } = await ECM.DeleteDocument(this.getHash());

            this.value = [];
            this.isThumbnail = false;
          }
        });
    },

    async downloadDocument() {
      const { data } = await ECM.DownloadDocument(this.getHash());
      downloadFile(data.content, data.contentType, data.fileName.split('.').pop(), data.fileName.split('.').shift());
    }
  }
};
</script>
<style lang="scss" scoped>
.v-responsive__content {
  transition: 300ms;
  .hover-card-image {
    height: 106%;
    background: rgba($color: #000000, $alpha: 0.6);
    transition: 300ms;

    div {
      color: #fff;
      text-align: center;
      padding: 0 0 10px 0;
    }
  }
}
</style>
